<template>
	<div class="sk-widget menu-section-header">
		<div>
			<div class="menu-section-header-title">{{ menu.name }}</div>
			<div class="menu-section-header-schedule">
				<i class="sk-icon-clock-solid"></i>
				{{ menuScheduleRange }}
			</div>
			<div class="menu-section-header-restaurant">
				<i class="sk-icon-utensils-solid"></i>
				{{ menu.restaurantName }}
			</div>
		</div>
		<!-- <img
			class="menu-section-header-image"
			src="/images/2k-launch.png"
			alt="Menu Header Image"
		/> -->
	</div>
</template>

<style scoped>
.menu-section-header {
	background: var(--gR-base-80);
	height: 89px;
	margin-top: 24px !important;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.menu-section-header > div {
	padding: 0 15px;
}

.menu-section-header-image {
	height: 100%;
	margin-right: 15px;
}

.menu-section-header-title,
.menu-section-header-schedule,
.menu-section-header-restaurant,
.menu-section-header-schedule i,
.menu-section-header-restaurant i {
	color: var(--gR-white);
}

.menu-section-header-title {
	font-size: 14px;
	font-weight: 600;
}

.menu-section-header-title,
.menu-section-header-schedule {
	margin-bottom: 9px;
}

.menu-section-header-schedule,
.menu-section-header-restaurant {
	display: flex;
	align-items: center;
	font-size: 11px;
}

.menu-section-header-schedule i,
.menu-section-header-restaurant i {
	margin-right: 10px;
	font-size: 10px;
}
</style>

<script>
export default {
	name: "MenuSectionHeader",
	props: {
		menu: Object
	},
	computed: {
		menuScheduleRange() {
			if (this.menu.timeSlots.length > 1) {
				return `${this.menu.timeSlots[0].text} - ${
					this.menu.timeSlots[this.menu.timeSlots.length - 1].text
				}`
			} else if (this.menu.timeSlots.length > 0) {
				return this.menu.timeSlots[0].text
			}
		}
	}
}
</script>